export class CanaisComunicacaoWhatsAppSticker {
  public phone: string;
  public sticker: string;
  public guidclientenapis: string;

  constructor() { }
}
